import { ErrorHandler } from '@angular/core';
import { LoggerService } from 'projects/common/src/app/services';
import { IRequestError } from 'projects/common/src/app/interfaces/communication/request';

export class ErrorHandlerService extends ErrorHandler {

  constructor() {
    super();
  }

  public handleError(error: IRequestError): void {
    LoggerService.error('Error message:', error.message, error.extra);
  }
}
